import { ListChecks, Database, GitBranch, UserCheck } from 'lucide-react'

export const KYC_CHECKLIST_ICONS: Record<string, typeof ListChecks> = {
  ruleset: ListChecks,
  'cascade-sources': Database,
  decisioning: GitBranch,
  'manual-review': UserCheck,
}

export const KYC_CHECKLIST_DESCRIPTIONS: Record<string, string> = {
  ruleset: 'Decides what counts as a pass, a fail, or something a person should look at.',
  'cascade-sources': 'Cross-checks the applicant against government and credit-bureau records.',
  decisioning: 'Runs the checks in order and combines them into one overall result.',
  'manual-review': 'Anything unclear gets routed to a person instead of auto-failing.',
}

export function outcomePlainLabel(outcome: string, customerName: string | null): string {
  const name = customerName ?? 'This customer'
  if (outcome === 'PASS') return `${name} passed identity verification.`
  if (outcome === 'FAIL') return `${name} did not pass identity verification.`
  if (outcome === 'REFER') return `${name} needs a closer look from your team.`
  return `${name}'s result: ${outcome}`
}
